<template>
  <div v-if="!hide" id="calculatorView">
    <div class="calculatorInner">
      <div v-if="!keysonly" id="answerPanel">
        <div id="answerPanelInner">
          {{ text }} <div v-if="decimals || negative" id="backspace">
            <a href="#" draggable="false" @click.prevent="didTapDeleteKey()" @keydown.enter.prevent><img src="/images/backspaceButton.png" draggable="false"></a>
          </div>
        </div>
      </div>
      <div v-if="invertkeys" class="columns is-mobile">
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(1)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">1</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(2)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">2</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(3)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">3</span></a>
        </div>
      </div>
      <div v-else class="columns is-mobile">
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(7)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">7</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(8)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">8</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(9)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">9</span></a>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(4)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">4</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(5)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">5</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(6)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">6</span></a>
        </div>
      </div>
      <div v-if="invertkeys" class="columns is-mobile">
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(7)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">7</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(8)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">8</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(9)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">9</span></a>
        </div>
      </div>
      <div v-else class="columns is-mobile">
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(1)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">1</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(2)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">2</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(3)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">3</span></a>
        </div>
      </div>
      <div class="columns is-mobile">
        <div v-if="decimals" class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapDecimalKey()" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false">
            <span class="keyNum">.</span>
          </a>
        </div>
        <div v-else-if="negative" class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNegativeKey()" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">-</span></a>
        </div>
        <div v-else class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapDeleteKey()" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">⌫</span></a>
        </div>
        <div class="calcKey column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapNumberKey(0)" @keydown.enter.prevent><img src="/images/CalcButton.png" draggable="false"><span class="keyNum">0</span></a>
        </div>
        <div class="calcKey goButton column is-4" draggable="false">
          <a href="#" draggable="false" @click.prevent="didTapGo()" @keydown.enter.prevent><img src="/images/CalcTickButton.png" draggable="false"></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StylingMixin from '@/mixins/Helpers'
export default {
  name: 'NumberCalculatorAnswerView',
  mixins: [StylingMixin],
  props: ['decimals', 'negative', 'text', 'disabled', 'invertkeys', 'hide', 'keysonly'],
  data (router) {
    return {
      // answerText: '0'
    }
  },
  created () {
    window.addEventListener('keyup', this.didKeyUp)
  },
  destroyed () {
    window.removeEventListener('keyup', this.didKeyUp)
  },
  methods: {
    didTapNumberKey (num) {
      let answerText = this.text
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }
      if (answerText === '0') {
        answerText = ''
      }
      if (answerText.length < 9) {
        answerText = answerText + num
      }
      this.$emit('calcTextChanged', answerText)
    },
    didTapDecimalKey () {
      let answerText = this.text
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }
      if (!answerText.includes('.')) {
        answerText = answerText + '.'
      }
      this.$emit('calcTextChanged', answerText)
    },
    didTapNegativeKey () {
      let answerText = this.text
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }
      if (answerText === '0') {
        answerText = '-'
      } else if (answerText[0] === '-') {
        answerText = answerText.replace('-', '')
      } else {
        answerText = `-${answerText}`
      }
      this.$emit('calcTextChanged', answerText)
    },
    didTapDeleteKey () {
      let answerText = this.text
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }
      if (answerText.length > 0) {
        answerText = answerText.slice(0, -1)
      }
      if (answerText.length === 0) {
        answerText = '0'
      }
      this.$emit('calcTextChanged', answerText)
    },
    didTapGo () {
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }
      this.$emit('answerClicked', this.text)
    },
    didKeyUp (event) {
      if (this.disabled) {
        return
      }
      const c = String.fromCharCode(event.which).toLocaleLowerCase()
      // console.log(c)
      // console.log(event.which)
      if (c === '1') {
        this.didTapNumberKey(1)
      } else if (c === '2') {
        this.didTapNumberKey(2)
      } else if (c === '3') {
        this.didTapNumberKey(3)
      } else if (c === '4') {
        this.didTapNumberKey(4)
      } else if (c === '5') {
        this.didTapNumberKey(5)
      } else if (c === '6') {
        this.didTapNumberKey(6)
      } else if (c === '7') {
        this.didTapNumberKey(7)
      } else if (c === '8') {
        this.didTapNumberKey(8)
      } else if (c === '9') {
        this.didTapNumberKey(9)
      } else if (c === '0') {
        this.didTapNumberKey(0)
      } else if (c === '.' || event.which === 190 || event.which === 110) {
        this.didTapDecimalKey()
      } else if (event.which === 8) {
        event.preventDefault()
        this.didTapDeleteKey()
      } else if (event.which === 13) {
        this.didTapGo()
      } else if (event.which >= 96 && event.which <= 105) {
        this.didTapNumberKey(event.which - 96)
      } else if (event.which === 189) {
        this.didTapNegativeKey()
      }
    }
  }
}
</script>
<style scoped>
  #calculatorView {
    margin: 50px auto 0;
    max-height:100vh;
    max-width:420px;
    box-shadow: 0 0 0 10px #e9ce1d;
    border-radius: 12px;
    background-color:#f6efa2;
    display: block;
  }

  .calculatorInner {
    background-color: #f6efa2;
    border-radius: 12px;
    box-shadow: inset 0 0 5px 1px rgba(23,20,3,0.5);
    margin: 0 auto -1px;
  }

  .calculatorInner .columns {
    padding: 0 20px;
    margin-bottom: 0;
  }

  #answerPanel {
    padding: 12px;
  }

  #answerPanelInner {
    background: #615d5d; /* Old browsers */
    background: -moz-linear-gradient(top, #615d5d 0%, #1a1a1a 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #615d5d 0%,#1a1a1a 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #615d5d 0%,#1a1a1a 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    height: 96px;
    border-radius: 8px;
    font-family: var(--user-chosen-font);
    color: white;
    text-align: right;
    font-size: 3em;
    padding: 10px;
  }

  #backspace {
    height: 100%;
    float: right;
    margin-left: 10px;
  }

  #backspace img {
    height: 70%;
  }

  .calcKey {
    text-align: center;
    position:relative;
    /* -webkit-transition: -webkit-transform .15s ease-in-out;
    transition: transform .15s ease-in-out; */
  }
  .calcKey img {
    max-width: 100%;

  }

  .calcKey:click {
    /* -webkit-transform: scale(0.95);
    transform: scale(0.95); */
  }

  .calcKey .keyNum {
    position: absolute;
    top: 14%;
    font-size: 2.5em;
    left: 0;
    right: 0;
    font-family: var(--user-chosen-font);
    color: white;
  }
</style>
